/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxcTradereportingV1CaisReportState } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXC_TRADEREPORTING_V1_CAIS_REPORT_STATE_ENTITY_NAME = 'ixc.tradereporting.v1.CaisReport';
export const ixcTradereportingV1CaisReportStateEntity = new schema.Entity<IxcTradereportingV1CaisReportState>(IXC_TRADEREPORTING_V1_CAIS_REPORT_STATE_ENTITY_NAME, {}, { idAttribute: 'reportId' });

